import React, { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppContext } from '../../../App'
import Spinner from '../../../components.js/elements/Spinner'
import ModalDeleteService from '../../../components.js/serveur/services/ModalDeleteService'
import ModalList from '../../../components.js/serveur/services/ModalList'
import ModalService from '../../../components.js/serveur/services/ModalService'
import ViewServices from '../../../components.js/serveur/services/ViewServices'
import HeaderReturn from '../../../components.js/serveur/siteWeb/HeaderReturn'
import useFirebase from '../../../firebase/useFirebase'
import useForm from '../../../hooks/useForm'
import ModalDeleteList from './../../../components.js/serveur/services/ModalDeleteList'
// IMAGES
import imageServices from '../../../images/service.png'

const INITIAL_STATE = {
    nameList:'',
    nameService:'',
    priceService:'',
    durationService:'',
    monTest:'',
}

const Services = () => {
    const { user } = useContext(AppContext)
    const { handleChange, values, refresh } = useForm(INITIAL_STATE)
    const { writeData, deleteData, readData, updateData, services, staff } = useFirebase()
    const [montage, setMontage] = useState(true)
    const [idList, setIdList] = useState()
    const [nameList2, setNameList2] = useState()
    const [idServiceModal, setIdServiceModal] = useState()
    const [count, setCount] = useState(0)

    useEffect(() => {
        readData(user.uid)
        window.scrollTo(0, 0)
        setMontage(false)
        console.log('services useeffect ',)
    },[])

    useEffect(() => {
        refresh()
    },[count])

    useEffect(() => { refresh()},[services])

    if (montage) return <Spinner />

    const handleAddList = (nameList) => {
        const data = {nameList:nameList,doc:'docList'}
        writeData('entreprises/'+user.uid+'/services',data)
        refresh()
    }

    const handleAddService = (nameService, priceService, durationService, caseStaff) => {
        const idService = Date.now()
        const data = {nameService:nameService, priceService:priceService, durationService:durationService ,doc:'docService', nameList:nameList2}
        // writeData('entreprises/'+user.uid+'/services',data)
        updateData('entreprises/'+user.uid+'/services/'+idService,data)
        staff.map(st => st.id === updateData('entreprises/'+user.uid+'/services/'+idService,{[st.id]:caseStaff[st.id]}))
        refresh()
    }

    const handleDeleteList = () => {
        services.filter(s => s.nameList === nameList2).map(s => (
            deleteData('entreprises/'+user.uid+'/services/'+s.id)
        ))
        deleteData('entreprises/'+user.uid+'/services/'+idList)
    }

    const _handleDelete = () => {
        deleteData('entreprises/'+user.uid+'/services/'+idServiceModal)
    } 

    return (
        <div className='container-fluid'> 
            <HeaderReturn 
                title='Services' 
                link='/homeServeur' 
                image={imageServices}
            />
            <ViewServices 
                services={services} 
                setIdList={setIdList} 
                setNameList2={setNameList2} 
                setIdServiceModal={setIdServiceModal}
            />
            <ModalList 
                handleAddList={handleAddList} 
                handleChange={handleChange} 
                values={values} 
                count={count}
                setCount={setCount}
            /> 
            <ModalService  
                handleAddService={handleAddService} 
                handleChange={handleChange} 
                values={values} 
                staff={staff}
                services={services}
                count={count}
                setCount={setCount}
            />
            <ModalDeleteList 
                handleDeleteList={handleDeleteList} 
                values={values} 
            />
            <ModalDeleteService
                _handleDelete={_handleDelete}
                setIdServiceModal={setIdServiceModal}
            />
        </div>
    )
}

export default Services